import {Typography} from '@mui/material';
import {t} from 'i18next';
import ArrModal from '../../../../common/arr-modal/ArrModal';

interface ReviseProtocolModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isConfirming?: boolean;
}

const ReviseProtocolModal = ({
  open,
  onClose,
  onConfirm,
  isConfirming = false,
}: ReviseProtocolModalProps) => {
  return (
    <ArrModal
      showModal={open}
      onClose={onClose}
      showClose={false}
      title={t('ai.review.protocolIntelligence.reviseProtocolModalTitle')}
      aria-label="revise-protocol-modal"
      dataTestId="revise-protocol-modal"
      buttons={[
        {
          id: 'revise-protocol-cancel',
          label: t('ai.review.protocolIntelligence.reviseProtocolModalCancel'),
          onClick: onClose,
          variant: 'secondary',
          disabled: isConfirming,
          dataTestId: 'revise-protocol-modal-cancel',
        },
        {
          id: 'revise-protocol-confirm',
          label: t('ai.review.protocolIntelligence.reviseProtocolModalConfirm'),
          onClick: onConfirm,
          variant: 'primary',
          disabled: isConfirming,
          dataTestId: 'revise-protocol-modal-confirm',
        },
      ]}
    >
      <Typography
        className="typo-text body2_size text-body-strong"
        data-testid="revise-protocol-modal-description"
      >
        {t('ai.review.protocolIntelligence.reviseProtocolModalDescription')}
      </Typography>
    </ArrModal>
  );
};

export default ReviseProtocolModal;
